import { https } from "../http";
import store from "../store";
import {
  setAddBillingInvoicesLoading,
  setAllBillinginvoices,
  setAllBillinginvoicesConsumers,
  setAllBillingPaidinvoices,
  setAllBillingRecurringinvoices,
  setAllCashChequeInvoices,
  setLoading,
} from "../store/reducers/billinginvoice";
import {
  setSkypointAddBillingInvoicesLoading,
  setSkypointAllBillinginvoices,
  setSkypointAllBillinginvoicesConsumers,
  setSkypointAllBillingPaidinvoices,
  setSkypointAllBillingRecurringinvoices,
  setSkypointAllCashChequeInvoices,
  setSkypointLoading,
} from "../store/reducers/skypointBillinginvoice";
import { showError } from "../utils/index";

// POST  // CREATE BILLING INVOICES
const createBillingInvoices = async (data, callback) => {
  try {
    store.dispatch(setAddBillingInvoicesLoading(true));
    let response = await https().post("billingInvoices", data);
    console.log("response in the action", response);

    if (response?.status === 200) {
      //  getAllBillingConsumers()
      // getReports(false);
      callback?.();
    }

    return response;
  } catch (error) {
    store.dispatch(setAddBillingInvoicesLoading(false));
    showError(error?.response?.data?.message, error?.response?.status);
    return false;
  }
};

// POST  // CREATE BILLING INVOICES SKYPOINT
const createBillingInvoicesSkypoint = async (data, callback) => {
  try {
    store.dispatch(setSkypointAddBillingInvoicesLoading(true));
    let response = await https().post("billingInvoices/skypoint", data);
    console.log("response in the action", response);

    if (response?.status === 200) {
      callback?.();
    }

    return response;
  } catch (error) {
    store.dispatch(setSkypointAddBillingInvoicesLoading(false));
    showError(error?.response?.data?.message, error?.response?.status);
    return false;
  }
};


// UPDATE BILLING STATUS


const UpdateBillingInvoicesStatus = async (data, callback,showLoading = true) => {
  try {
    store.dispatch(setAddBillingInvoicesLoading(true));
    let response = await https().post("billingInvoices/update-status-paid", data);
    console.log("response in the action", response);

    if (response?.status === 200) {
      //  getAllBillingConsumers()
      // getReports(false);
      getAllBillingInvoices(showLoading);
      // callback?.();
    }

    return response;
  } catch (error) {
    store.dispatch(setAddBillingInvoicesLoading(false));
    showError(error?.response?.data?.message, error?.response?.status);
    return false;
  }
};


const UpdateBillingInvoicesStatusSkypoint = async (data, callback,showLoading = true) => {
  try {
    store.dispatch(setSkypointAddBillingInvoicesLoading(true));
    let response = await https().post("billingInvoices/skypoint/update-status-paid", data);
    console.log("response in the action", response);

    if (response?.status === 200) {
      getAllBillingInvoicesSkypoint(showLoading);
    }

    return response;
  } catch (error) {
    store.dispatch(setSkypointAddBillingInvoicesLoading(false));
    showError(error?.response?.data?.message, error?.response?.status);
    return false;
  }
};


// Resend Billing Invoice Email

const resendInvoiceEmail = async (data, callback,showLoading = true) => {
  try {
    store.dispatch(setAddBillingInvoicesLoading(true));
    let response = await https().post("billingInvoices/resend-invoice-email", data);
    console.log("response in the action", response);

    if (response?.status === 200) {
      //  getAllBillingConsumers()
      // getReports(false);
      getAllBillingInvoices(showLoading);
      // callback?.();
    }

    return response;
  } catch (error) {
    store.dispatch(setAddBillingInvoicesLoading(false));
    showError(error?.response?.data?.message, error?.response?.status);
    return false;
  }
};

const resendInvoiceEmailSkypoint = async (data, callback,showLoading = true) => {
  try {
    store.dispatch(setSkypointAddBillingInvoicesLoading(true));
    let response = await https().post("billingInvoices/skypoint/resend-invoice-email", data);
    console.log("response in the action", response);

    if (response?.status === 200) {
      getAllBillingInvoicesSkypoint(showLoading);
    }

    return response;
  } catch (error) {
    store.dispatch(setSkypointAddBillingInvoicesLoading(false));
    showError(error?.response?.data?.message, error?.response?.status);
    return false;
  }
};


//get BILLING INVOICES

const getAllBillingInvoices = async (payload, showLoading = true) => {
  const { customerId, page, selectedMonth, query } = payload || {};
  let response;

  if (showLoading) store.dispatch(setLoading(true));

  // Construct URL based on payload parameters
  let url = `billingInvoices/${page ? page : "all"}/${selectedMonth || 1}`;
  if (customerId) {
    url += `?customerId=${customerId}`;
  }
  if (query) {
    url += `?query=${encodeURIComponent(query)}`;
  }
  try {
    response = await https().get(url);
    if (response?.status === 200) {
      store.dispatch(setAllBillinginvoices(response.data));
      return response;
    }
  } catch (error) {
    showError(error?.response?.data?.message, error?.response?.status);
    return false;
  } finally {
    if (showLoading) store.dispatch(setLoading(false));
  }
};

const getAllBillingInvoicesSkypoint = async (payload, showLoading = true) => {
  const { customerId, page, selectedMonth, query } = payload || {};
  let response;

  if (showLoading) store.dispatch(setSkypointLoading(true));

  // Construct URL based on payload parameters
  let url = `billingInvoices/skypoint/${page ? page : "all"}/${selectedMonth || 1}`;
  if (customerId) {
    url += `?customerId=${customerId}`;
  }
  if (query) {
    url += `?query=${encodeURIComponent(query)}`;
  }
  try {
    response = await https().get(url);
    if (response?.status === 200) {
      store.dispatch(setSkypointAllBillinginvoices(response.data));
      return response;
    }
  } catch (error) {
    showError(error?.response?.data?.message, error?.response?.status);
    return false;
  } finally {
    if (showLoading) store.dispatch(setSkypointLoading(false));
  }
};

// const getAllBillingInvoices = async (payload, showLoading = true) => {
//   console.log("payload", payload);

//   const customerId = payload?.customerId;
//   try {
//     if (showLoading) store.dispatch(setLoading(true));

//     if (customerId) {
//       let response = await https().get(
//         `billingInvoices/${payload && payload.page ? `${payload.page}` : "all"}/${
//           payload?.selectedMonth || 1
//         }?customerId=${payload?.customerId}`
//       );
//     } else {
//       let response = await https().get(
//         `billingInvoices/${payload && payload.page ? `${payload.page}` : "all"}/${
//           payload?.selectedMonth || 1
//         }`
//       );
//     }

//     if (response?.status === 200) {
//       store.dispatch(setAllBillinginvoices(response?.data));
//       store.dispatch(setLoading(false));
//       return response;
//     }
//   } catch (error) {
//     store.dispatch(setLoading(false));
//     showError(error?.response?.data?.message, error?.response?.status);
//     return false;
//   }
// };

// EDIT BILLING INVOICE

const EditBillingInvoice = async (data, showLoading = true) => {
  try {
    store.dispatch(setAddBillingInvoicesLoading(true));
    let response = await https().put(`/billingInvoices/${data?.id}`, data);

    if (response?.status === 200) {
    let payload = {
      page: 1,
    };
      getAllBillingRecurringInvoices(payload);
      getAllBillingInvoices(showLoading);
    }

    return response;
  } catch (error) {
    store.dispatch(setAddBillingInvoicesLoading(false));
    showError(error?.response?.data?.message, error?.response?.status);
  }
};

// EDIT BILLING INVOICE SKYPOINT

const EditBillingInvoiceSkypoint = async (data, showLoading = true) => {
  try {
    store.dispatch(setSkypointAddBillingInvoicesLoading(true));
    let response = await https().put(`/billingInvoices/skypoint/${data?.id}`, data);

    if (response?.status === 200) {
    let payload = {
      page: 1,
    };
      getAllBillingRecurringInvoicesSkypoint(payload);
      getAllBillingInvoicesSkypoint(showLoading);
    }

    return response;
  } catch (error) {
    store.dispatch(setSkypointAddBillingInvoicesLoading(false));
    showError(error?.response?.data?.message, error?.response?.status);
  }
};

// DELETE BILLING INVOICES

const removeBillingInvoice = async (data, showLoading = true) => {
  try {
    store.dispatch(setAddBillingInvoicesLoading(true));

    // console.log('data',data);

    let response = await https().delete(`/billingInvoices/${data?.id}`);

    if (response?.status === 200) {
      await getAllBillingInvoices((showLoading = true));
      await getAllBillingRecurringInvoices((showLoading = true));
    }

    return response;
  } catch (error) {
    store.dispatch(setAddBillingInvoicesLoading(false));
    showError(error?.response?.data?.message, error?.response?.status);
  }
};

// DELETE BILLING INVOICES SKYPOINT

const removeBillingInvoiceSkypoint = async (data, showLoading = true) => {
  try {
    store.dispatch(setSkypointAddBillingInvoicesLoading(true));

    let response = await https().delete(`/billingInvoices/skypoint/${data?.id}`);

    if (response?.status === 200) {
      await getAllBillingInvoicesSkypoint((showLoading = true));
      await getAllBillingRecurringInvoicesSkypoint((showLoading = true));
    }

    return response;
  } catch (error) {
    store.dispatch(setSkypointAddBillingInvoicesLoading(false));
    showError(error?.response?.data?.message, error?.response?.status);
  }
};

// POST CREATE BILLING COSUMER
const createBillingconsumer = async (data, callback) => {
  try {
    store.dispatch(setAddBillingInvoicesLoading(true));
    let response = await https().post("billingconsumer", data);

    if (response?.status === 200) {
      //  getAllBillingConsumers()
      // getReports(false);
      callback?.();
    }

    return response;
  } catch (error) {
    store.dispatch(setAddBillingInvoicesLoading(false));
    showError(error?.response?.data?.message, error?.response?.status);
    return false;
  }
};

// POST CREATE BILLING COSUMER SKYPOINT
const createBillingconsumerSkypoint = async (data, callback) => {
  try {
    store.dispatch(setSkypointAddBillingInvoicesLoading(true));
    let response = await https().post("billingconsumer/skypoint", data);

    if (response?.status === 200) {
      callback?.();
    }

    return response;
  } catch (error) {
    store.dispatch(setSkypointAddBillingInvoicesLoading(false));
    showError(error?.response?.data?.message, error?.response?.status);
    return false;
  }
};




//get BILLING CONSUMER

// const getAllBillingConsumers = async (payload, showLoading = true) => {
//   try {
//     const { page, query } = payload || {};
//     if (showLoading) store.dispatch(setLoading(true));
//     let response = await https().get(
//       `billingconsumer/${page ? page : "all"}${
//         query ? `?query=${encodeURIComponent(query)}` : ""
//       }`
//     );
//     store.dispatch(setAllBillinginvoicesConsumers(response?.data));
//     if (response?.status === 200) {
//       store.dispatch(setAllBillinginvoicesConsumers(response?.data));
//     }
//   } catch (error) {
//     store.dispatch(setLoading(false));
//     showError(error?.response?.data?.message, error?.response?.status);
//     return false;
//   }
// };

const getAllBillingConsumers = async (payload, showLoading = true) => {
  try {
    const { page, query, status } = payload || {}; 
    if (showLoading) store.dispatch(setLoading(true));
    
    let url = `billingconsumer/${page ? page : "all"}`;
    
    // Check if there's a query or status to append to the URL
    let params = [];
    if (query) {
      params.push(`query=${encodeURIComponent(query)}`);
    }
    if (status) {
      params.push(`status=${encodeURIComponent(status)}`);
    }
    
    // Join parameters if they exist and append to the URL
    if (params.length > 0) {
      url += `?${params.join('&')}`;
    }


    let response = await https().get(url);


    store.dispatch(setAllBillinginvoicesConsumers(response?.data));

    if (response?.status === 200) {
      store.dispatch(setAllBillinginvoicesConsumers(response?.data));
    }
  } catch (error) {
    store.dispatch(setLoading(false));
    showError(error?.response?.data?.message, error?.response?.status);
    return false;
  }
};

const getAllBillingConsumersSkypoint = async (payload, showLoading = true) => {
  try {
    const { page, query, status } = payload || {};
    if (showLoading) store.dispatch(setSkypointLoading(true));

    let url = `billingconsumer/skypoint/${page ? page : "all"}`;

    let params = [];
    if (query) {
      params.push(`query=${encodeURIComponent(query)}`);
    }
    if (status) {
      params.push(`status=${encodeURIComponent(status)}`);
    }

    if (params.length > 0) {
      url += `?${params.join('&')}`;
    }

    let response = await https().get(url);

    store.dispatch(setSkypointAllBillinginvoicesConsumers(response?.data));

    if (response?.status === 200) {
      store.dispatch(setSkypointAllBillinginvoicesConsumers(response?.data));
    }
  } catch (error) {
    store.dispatch(setSkypointLoading(false));
    showError(error?.response?.data?.message, error?.response?.status);
    return false;
  }
};


// EDIT BILLING CONSUMER

const editConsumer = async (data, showLoading = true) => {
  try {
    store.dispatch(setAddBillingInvoicesLoading(true));
    let response = await https().put(`/billingconsumer/${data?.id}`, data);

    if (response?.status === 200) {
      getAllBillingConsumers(showLoading);
    }

    return response;
  } catch (error) {
    store.dispatch(setAddBillingInvoicesLoading(false));
    showError(error?.response?.data?.message, error?.response?.status);
  }
};

// EDIT BILLING CONSUMER SKYPOINT

const editConsumerSkypoint = async (data, showLoading = true) => {
  try {
    store.dispatch(setSkypointAddBillingInvoicesLoading(true));
    let response = await https().put(`/billingconsumer/skypoint/${data?.id}`, data);

    if (response?.status === 200) {
      getAllBillingConsumersSkypoint(showLoading);
    }

    return response;
  } catch (error) {
    store.dispatch(setSkypointAddBillingInvoicesLoading(false));
    showError(error?.response?.data?.message, error?.response?.status);
  }
};

// DELETE BILLING CONSUMER

const removeBillingConsumer = async (data, showLoading = true) => {
  try {
    store.dispatch(setAddBillingInvoicesLoading(true));

    // console.log('data',data);

    let response = await https().delete(`/billingconsumer/${data?.id}`);

    if (response?.status === 200) {
      await getAllBillingConsumers((showLoading = true));
    }

    return response;
  } catch (error) {
    store.dispatch(setAddBillingInvoicesLoading(false));
    showError(error?.response?.data?.message, error?.response?.status);
  }
};

// DELETE BILLING CONSUMER SKYPOINT

const removeBillingConsumerSkypoint = async (data, showLoading = true) => {
  try {
    store.dispatch(setSkypointAddBillingInvoicesLoading(true));

    let response = await https().delete(`/billingconsumer/skypoint/${data?.id}`);

    if (response?.status === 200) {
      await getAllBillingConsumersSkypoint((showLoading = true));
    }

    return response;
  } catch (error) {
    store.dispatch(setSkypointAddBillingInvoicesLoading(false));
    showError(error?.response?.data?.message, error?.response?.status);
  }
};

//get BILLING RECURRING INVOICES

const getAllBillingRecurringInvoices = async (payload, showLoading = true) => {
  try {
    const { query, page } = payload;
    if (showLoading) store.dispatch(setLoading(true));
    //   let response = await https().get(`billingInvoices/all`);
    let response = await https().get(
      `billingInvoices/get-recurring-invoices/${page ? page : 'all'}${
        query ? `?query=${encodeURIComponent(query)}` : ""
      }`
    );

    store.dispatch(setAllBillingRecurringinvoices(response?.data));
    if (response?.status === 200) {
      store.dispatch(setAllBillingRecurringinvoices(response?.data));
    }
  } catch (error) {
    store.dispatch(setLoading(false));
    showError(error?.response?.data?.message, error?.response?.status);
    return false;
  }
};

//get BILLING RECURRING INVOICES SKYPOINT

const getAllBillingRecurringInvoicesSkypoint = async (payload, showLoading = true) => {
  try {
    const { query, page } = payload;
    if (showLoading) store.dispatch(setSkypointLoading(true));
    let response = await https().get(
      `billingInvoices/skypoint/get-recurring-invoices/${page ? page : 'all'}${
        query ? `?query=${encodeURIComponent(query)}` : ""
      }`
    );

    store.dispatch(setSkypointAllBillingRecurringinvoices(response?.data));
    if (response?.status === 200) {
      store.dispatch(setSkypointAllBillingRecurringinvoices(response?.data));
    }
  } catch (error) {
    store.dispatch(setSkypointLoading(false));
    showError(error?.response?.data?.message, error?.response?.status);
    return false;
  }
};

const getAllBillingPaidInvoices = async (payload, showLoading = true) => {
  try {
    const { query, page } = payload;
    if (showLoading) store.dispatch(setLoading(true));
    //   let response = await https().get(`billingInvoices/all`);
    let response = await https().get(
      `billingInvoices/get-paidinvoices/${page ? page : 'all'}${
        query ? `?query=${encodeURIComponent(query)}` : ""
      }`
    );

    store.dispatch(setAllBillingPaidinvoices(response?.data));
    if (response?.status === 200) {
      store.dispatch(setAllBillingPaidinvoices(response?.data));
    }
  } catch (error) {
    store.dispatch(setLoading(false));
    showError(error?.response?.data?.message, error?.response?.status);
    return false;
  }
};

const getAllBillingPaidInvoicesSkypoint = async (payload, showLoading = true) => {
  try {
    const { query, page } = payload;
    if (showLoading) store.dispatch(setSkypointLoading(true));
    let response = await https().get(
      `billingInvoices/skypoint/get-paidinvoices/${page ? page : 'all'}${
        query ? `?query=${encodeURIComponent(query)}` : ""
      }`
    );

    store.dispatch(setSkypointAllBillingPaidinvoices(response?.data));
    if (response?.status === 200) {
      store.dispatch(setSkypointAllBillingPaidinvoices(response?.data));
    }
  } catch (error) {
    store.dispatch(setSkypointLoading(false));
    showError(error?.response?.data?.message, error?.response?.status);
    return false;
  }
};

// get single billing invoice

const getSingleBillingInvoices = async (payload, showLoading = true) => {
  try {
    const {query} = payload;
    if (showLoading) store.dispatch(setLoading(true));
    //   let response = await https().get(`billingInvoices/all`);
    let response = await https().get(
      `billingInvoices/get-single-invoices${
        query ? `?query=${encodeURIComponent(query)}` : ""
      }`
    );


    if (response?.status === 200) {
    return response
    }
  } catch (error) {
    store.dispatch(setLoading(false));
    showError(error?.response?.data?.message, error?.response?.status);
    return false;
  }
};

// get single billing invoice skypoint

const getSingleBillingInvoicesSkypoint = async (payload, showLoading = true) => {
  try {
    const {query} = payload;
    if (showLoading) store.dispatch(setSkypointLoading(true));
    //   let response = await https().get(`billingInvoices/all`);
    let response = await https().get(
      `billingInvoices/skypoint/get-single-invoices${
        query ? `?query=${encodeURIComponent(query)}` : ""
      }`
    );


    if (response?.status === 200) {
    return response
    }
  } catch (error) {
    store.dispatch(setSkypointLoading(false));
    showError(error?.response?.data?.message, error?.response?.status);
    return false;
  }
};

// get Report of Invoices

const createBillingReportInvoices = async (data, callback) => {
  try {
    store.dispatch(setAddBillingInvoicesLoading(true));
    let response = await https().post("billingInvoices/report", data);
    console.log("response in the action", response);

    if (response?.status === 200) {
      //  getAllBillingConsumers()
      // getReports(false);
      callback?.();
    }

    return response;
  } catch (error) {
    store.dispatch(setAddBillingInvoicesLoading(false));
    showError(error?.response?.data?.message, error?.response?.status);
    return false;
  }
};

// get Report of Invoices skypoint

const createBillingReportInvoicesSkypoint = async (data, callback) => {
  try {
    store.dispatch(setSkypointAddBillingInvoicesLoading(true));
    let response = await https().post("billingInvoices/skypoint/report", data);
    console.log("response in the action", response);

    if (response?.status === 200) {
      callback?.();
    }

    return response;
  } catch (error) {
    store.dispatch(setSkypointAddBillingInvoicesLoading(false));
    showError(error?.response?.data?.message, error?.response?.status);
    return false;
  }
};


// get cash and cheques invoices


const getAllCashAndChequeInvoice = async (payload, showLoading = true) => {
  try {

   


    

    let response = await https().get("billingInvoices/cash-cheque");


     store.dispatch(setAllCashChequeInvoices(response?.data));

    return response

  } catch (error) {
    store.dispatch(setLoading(false));
    showError(error?.response?.data?.message, error?.response?.status);
    return false;
  }
};

// get cash and cheques invoices skypoint


const getAllCashAndChequeInvoiceSkypoint = async (payload, showLoading = true) => {
  try {
    let response = await https().get("billingInvoices/skypoint/cash-cheque");
    store.dispatch(setSkypointAllCashChequeInvoices(response?.data));
    return response
  } catch (error) {
    store.dispatch(setSkypointLoading(false));
    showError(error?.response?.data?.message, error?.response?.status);
    return false;
  }
};

// PAUSED RECURRING INVOICE
const PausedRecurringInvoice = async (data, showLoading = true) => {
  try {
    store.dispatch(setAddBillingInvoicesLoading(true));
    let response = await https().post("billingInvoices/pause-recurring-invoice", data);
    if (response?.status === 200) {
          let payload = {
      page: 1,
    };
      getAllBillingRecurringInvoices(payload);
    }
    return response;
  } catch (error) {
    store.dispatch(setAddBillingInvoicesLoading(false));
    showError(error?.response?.data?.message, error?.response?.status);
  }
};

// PAUSED RECURRING INVOICE
const PausedRecurringInvoiceSkypoint = async (data, showLoading = true) => {
  try {
    store.dispatch(setSkypointAddBillingInvoicesLoading(true));
    let response = await https().post("billingInvoices/skypoint/pause-recurring-invoice", data);
    if (response?.status === 200) {
      let payload = {
        page: 1,
      };
      getAllBillingRecurringInvoicesSkypoint(payload);
    }
    return response;
  } catch (error) {
    store.dispatch(setSkypointAddBillingInvoicesLoading(false));
    showError(error?.response?.data?.message, error?.response?.status);
  }
};

export {
  createBillingInvoices,
  createBillingInvoicesSkypoint,
  getAllBillingConsumers,
  getAllBillingInvoices,
  resendInvoiceEmail,
  createBillingconsumer,
  getAllBillingRecurringInvoices,
  getAllBillingPaidInvoices,
  editConsumer,
  EditBillingInvoice,
  removeBillingInvoice,
  removeBillingConsumer,
  createBillingReportInvoices,
  UpdateBillingInvoicesStatus,
  getSingleBillingInvoices,
  getAllCashAndChequeInvoice,
  UpdateBillingInvoicesStatusSkypoint,
  EditBillingInvoiceSkypoint,
  resendInvoiceEmailSkypoint,
  getAllBillingRecurringInvoicesSkypoint,
  getAllBillingPaidInvoicesSkypoint,
  getSingleBillingInvoicesSkypoint,
  removeBillingInvoiceSkypoint,
  getAllBillingInvoicesSkypoint,
  PausedRecurringInvoice,
  createBillingReportInvoicesSkypoint,
  getAllCashAndChequeInvoiceSkypoint,
  createBillingconsumerSkypoint,
  getAllBillingConsumersSkypoint,
  editConsumerSkypoint,
  removeBillingConsumerSkypoint,
  PausedRecurringInvoiceSkypoint,
  // editBillingclient
};
